import { RouteConfig } from 'vue-router'
import UserProfileLayout from '@/views/layouts/UserProfileLayout.vue'
import Achievement from '@/views/userProfile/Achievement.vue'
import Career from '@/views/userProfile/Career.vue'
import PersonalInfo from '@/views/userProfile/PersonalInfo.vue'
import Privacy from '@/views/userProfile/Privacy.vue'
import Security from '@/views/userProfile/Security.vue'
import WorkEducation from '@/views/userProfile/WorkEducation.vue'
import ProfilePreview from '@/views/userProfile/ProfilePreview.vue'
import { ROLES } from '@/store'

export default {
  path: '/profile',
  component: UserProfileLayout,
  meta: {
    requiresAuth: true,
    allowedRoles: [
      ROLES.learner
    ]
  },
  children: [
    {
      path: '/',
      name: 'Profile',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'profile'
      },
      component: PersonalInfo
    },
    {
      path: 'workeducation',
      name: 'Work Education',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'profile'
      },
      component: WorkEducation
    },
    {
      path: 'career',
      name: 'Career',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'profile'
      },
      component: Career
    },
    {
      path: 'achievement',
      name: 'Achievement',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'profile'
      },
      component: Achievement
    },
    {
      path: 'security',
      name: 'Change Password',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'settings'
      },
      component: Security
    },
    {
      path: 'privacy',
      name: 'Privacy',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'settings'
      },
      component: Privacy
    },
    {
      path: 'preview',
      name: 'Profile Preview',
      meta: {
        headerTitlei18n: 'profilePreview'
      },
      component: ProfilePreview
    }
  ]
} as RouteConfig
